"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordStrength = void 0;
var PasswordStrength;
(function (PasswordStrength) {
    PasswordStrength["WEAK"] = "weak";
    PasswordStrength["MEDIUM"] = "medium";
    PasswordStrength["STRONG"] = "strong";
    PasswordStrength["VERY_STRONG"] = "very_strong";
})(PasswordStrength || (exports.PasswordStrength = PasswordStrength = {}));
